import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe the executes encodeURIComponent on a string and returns the result
 */
@Pipe({
    name: 'encodeURI'
})
export class EncodeUriPipe implements PipeTransform {

    /**
     * Transforms the string and returns the result of encodeURIComponent
     * @param uri
     * @param attribute
     * @returns {any}
     */
    public transform(uri: string, attribute: string) {
        if (uri === undefined) { return ''; }

        return encodeURIComponent(String(uri));
    }
}